// extracted by mini-css-extract-plugin
export default {"horizontalScroller":"styles_horizontalScroller__Dgx3B","wrapper":"styles_wrapper__56fuP","selector":"styles_selector__DXtRu"};